import { createContext } from "react";

export const EditableInfoRowContext = createContext<
  ((value: string) => void) | null
>(null);
